import React from 'react';
import Swiper from 'react-id-swiper';
import './styles.scss';

export default class Slider extends Swiper {}
